import React from 'react';
import WhatsApp from '@material-ui/icons/WhatsApp';

export default function WhatsAppIcon(props) {
    const { ...other } = props;

    return (
        <WhatsApp {...other} />
    );
}